module.exports = __webpack_public_path__ + "static/media/2013_maleRate_femaleRate.9ca2e2fe.png";